/* istanbul ignore file */
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';

export const getInfoSectionLayoutCustomCssVars = ({styleParams, isRTL}: CustomCssVarsFnParams) => {
  const showInfoSectionDividers = styleParams.booleans.productPage_infoSectionShowDeviders;

  return {
    infoSectionCollapseIconOrder: isRTL ? '0' : '1',
    infoSectionCollapseTitleOrder: isRTL ? '1' : '0',
    infoSectionDirection: isRTL ? 'rtl' : 'ltr',
    stakedInfoItemBorderBottomWidth: showInfoSectionDividers ? '1px' : '0px',
    stakedInfoItemBorderBottomStyle: showInfoSectionDividers ? 'solid' : 'none',
    stakedInfoItemMarginBottom: showInfoSectionDividers ? '0px' : '20px',
    stakedInfoItemPadding: showInfoSectionDividers ? '20px 0' : '0px',
    columnsInfoItemBorderInlineEndWidth: showInfoSectionDividers ? '1px' : '0px',
    columnsInfoItemBorderInlineEndStyle: showInfoSectionDividers ? 'solid' : 'none',
  };
};
